import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  templateUrl: './recording-info-dialog.component.html',
  styleUrls: ['./recording-info-dialog.component.scss'],
  selector: 'meeting-analysis-recording-info-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule, RouterLink],
})
export class RecordingInfoDialogComponent {
  constructor(public dialogRef: MatDialogRef<RecordingInfoDialogComponent>) {}
}
